import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Flex from '../../Flex'
import Hide from '../../Hide'
import Copy from '../../Copy'
import Currency from '../../Currency'
import { themeColor } from '../../../util/themeLenses'
import { FormattedMessage } from 'react-intl'

export const Container = styled(Flex)`
    border-radius: 2px 0 0 2px;
`

export const ContainerOldPrice = styled.div`
    position: relative;
    &:after{
        content: '';
        position:absolute;
        left: 0;
        bottom: 0;
        border-top: 3px solid ${themeColor('accent')};
        width:100%;
        transform: rotate(340deg);
        transform-origin: 0% 0%;
    }
`

const PriceContainer = ({
    isSelected,
    webPrice,
    originalPrice,
}) => (
    <Container
      flexDirection={['column', 'row']}
      w={['100%', 'auto']}
      justifyContent='space-between'
      alignItems={['start', 'center']}
      p={['0.5em', '0']}
      background={isSelected ? 'main20' : 'main10'}>
        <Hide md lg>
            <Flex alignItems='center'>
                <Copy padding='0 1em 0 0' textAlign='center' color='gray' fontWeight='medium' transform='uppercase' fontSize='xLarge'>
                    <Currency qty={webPrice} />
                </Copy>
                {originalPrice && <Flex flexDirection='column'>
                    <Copy padding='0 0 0 12px' color='gray' fontWeight='regular' transform='uppercase' fontSize='xxxSmall'>
                        <FormattedMessage id='station-product-price-container-before' defaultMessage='Antes' />
                    </Copy>
                    <Copy padding='0 12px' color='gray' fontWeight='book' transform='uppercase' fontSize='medium'>
                        <ContainerOldPrice>
                            <Currency qty={originalPrice} />
                        </ContainerOldPrice>
                    </Copy>
                </Flex>
                }
            </Flex>
        </Hide>
        <Hide xs sm>
            <Copy padding='0 12px' textAlign='center' color='main' fontWeight='regular' transform='uppercase' fontSize='xxSmall'>
                <FormattedMessage id='station-product-price-container-after' defaultMessage='Desde' />
            </Copy>
            <Copy padding='0 12px' textAlign='center' color='main' fontWeight='bold' transform='uppercase' fontSize='large'>
                <Currency qty={webPrice} />
            </Copy>
            {originalPrice && <>
                <Copy padding='12px 12px 0 12px' textAlign='center' color='gray' fontWeight='regular' transform='uppercase' fontSize='xxSmall'>
                    <FormattedMessage id='station-product-price-container-before' defaultMessage='Antes' />
                </Copy>
                <Copy padding='0 12px' textAlign='center' color='gray' fontWeight='book' transform='uppercase' fontSize='medium'>
                    <ContainerOldPrice>
                        <Currency qty={originalPrice} />
                    </ContainerOldPrice>
                </Copy>
            </>
            }
        </Hide>
    </Container>
)

PriceContainer.propTypes = {
    isSelected: PropTypes.bool.isRequired,
    originalPrice: PropTypes.shape({
        amount: PropTypes.number,
        currency: PropTypes.string,
    }),
    webPrice: PropTypes.shape({
        amount: PropTypes.number,
        currency: PropTypes.string,
    }).isRequired,
}

export default PriceContainer
